import axios from 'axios';
import { baseUrl } from '../../config';

export const selectBaseUrl = () => baseUrl;

export const CustomAxios = axios.create({
  baseURL: selectBaseUrl(),
});
